import { createSlice} from '@reduxjs/toolkit';
import { apiCallBegan } from './api';
// import moment from 'moment';

const slice = createSlice({
  name: 'inventory',
  initialState: {
    airline: '',
    status: '',
    inventory:[],
    response:{}
  },
  reducers: {
    setAirline: (state, action) => {
      state.airline = action.payload
    },
    updateInventoryRequested: (state, action) => {
      if(action.payload==="")
      {
        state.status=""
        state.response={}
      }
      else{
      state.status = null
      }
    },
    getInventorySuccess: (state, action) => {
      state.inventory = action.payload
    },
    getInventoryError: (state, action) => {
      console.log(action.payload)
    },
    updateInventorySuccess: (state, action) => {
        state.status = true
    },

    updateInventoryFailure: (state, action) => {
      state.response=action.payload
      state.status = false
    }
  }
})

export const {updateInventoryRequested, updateInventorySuccess, updateInventoryFailure,getInventorySuccess,getInventoryError} = slice.actions;
export const { setAirline } = slice.actions;

// NOTE // api actions
// export const {  } = slice.actions;
export default slice.reducer;
export const updateInventory = (data) => (dispatch, getState) => {
  const url = `inventoryUpdater`;
  data.airlineId = 'TJ'

  // TODO // replace airlineId in commands if it's not TJ
  // 'IMN/-->TJ299<--/SVCPHX/07DEC21/07DEC21/1/YZ0:0,YX0:0,YE0:0,YC0:0,YY8:8^IMD/-->TJ299<--/SVCPHX/07DEC21/07DEC21/1/U'

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: data,
      onStart: updateInventoryRequested.type,
      onSuccess: updateInventorySuccess.type,
      onError: updateInventoryFailure.type,
    })
  )
}
export const getInventoryChoices = () => (dispatch, getState) => {
  const airline = getState().entities.inventory.airline
  const url = `inventoryUpdater/choices?airline=${airline}`; // Update the URL with the dynamic airline code
  return dispatch(
    apiCallBegan({
      url,
      method: 'get',
      onSuccess: getInventorySuccess.type,
      onError: getInventoryError.type,
    })
  );
};
